import { render, staticRenderFns } from "./SummaryPlatform.vue?vue&type=template&id=bf18b3cc"
import script from "./SummaryPlatform.vue?vue&type=script&lang=js"
export * from "./SummaryPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports